<template>
  <v-autocomplete
    v-model="address"
    :items="addressesList"
    :loading="loadingAddresses"
    :search-input.sync="searchAddress"
    :filter="() => true"
    :clearable="true"
    return-object
    hide-no-data
    hide-details
    placeholder="Saisissez une adresse"
    @click:clear="clear"
  />
</template>

<script>
import eventBus from '../../assets/event-bus.js'
import { mapState } from 'vuex'
import axios from 'axios'
const debounce = require('debounce')

export default {
  data: () => ({
    addressesList: [],
    searchAddress: '',
    loadingAddresses: false,
    address: null
  }),
  computed: {
    ...mapState(['datasets'])
  },
  watch: {
    searchAddress: debounce(async function () {
      this.loadingAddresses = true
      if (!this.searchAddress || this.searchAddress.length < 3) {
        this.addressesList = this.address ? [this.address] : []
      } else {
        const params = {
          q: this.searchAddress,
          lat: (Math.min(...this.datasets.map(d => d.bbox[1])) + Math.min(...this.datasets.map(d => d.bbox[3]))) / 2,
          lon: (Math.min(...this.datasets.map(d => d.bbox[0])) + Math.min(...this.datasets.map(d => d.bbox[2]))) / 2
        }
        const result = (await axios.get('https://api-adresse.data.gouv.fr/search/', { params })).data
        this.addressesList = result.features.map(f => ({ text: f.properties.label, value: f.geometry.coordinates.reverse().concat(f.properties.type) }))
      }
      this.loadingAddresses = false
    }, 300),
    address (addr) {
      if (addr) {
        eventBus.$emit('goTo', addr.value)
      }
    }
  },
  methods: {
    clear () {
      eventBus.$emit('clearAddress')
    }
  }
}
</script>
